import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    // Verify token is valid
    const decoded = JSON.parse(atob(token));
    if (!decoded.isAdmin) {
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
